import { getProfileToLocalDB } from "./profile";

export function saveToSessionStorage<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error saving to session storage:", error);
  }
}

export function getFromSessionStorage<T>(key: string): T | null {
  try {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    console.error("Error retrieving from session storage:", error);
    return null;
  }
}

export const getFMCGStoreIdFromSessionStorage = () => {
  try {
    return getProfileToLocalDB()?.fmcg_store_id || null;
  } catch {
    return null;
  }
};

export const setSessionStorageString = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {}
};

export const getSessionStorageString = (key: string, defaultValue: string) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return defaultValue || "";
  }
};
